import { useEffect } from 'react';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { toSuggestBody } from '../../suggest/selectors';
import { setZoneName } from '../../zone/actions';
import { getZonePoint } from '../../zone/selectors';
import { createAsyncState } from '../hooks';
import { getTariffsState } from './selectors';
var useZoneInfoAsync = createAsyncState('zoneInfo');
export var useZoneInfoQuery = function () {
    var _a = useStoreContext(), state = _a[0], dispatch = _a[1];
    var _b = useAPIContext(), suggest = _b.suggest, zoneInfo = _b.zoneInfo;
    var _c = useZoneInfoAsync(), asyncState = _c[0], actions = _c[1];
    var zonePoint = getZonePoint(state);
    useEffect(function () {
        if (suggest && zoneInfo && zonePoint) {
            var body = toSuggestBody('a', zonePoint, zonePoint);
            actions.start();
            var cancelZone_1 = suggest({
                body: body,
                onError: actions.error,
                onSuccess: function (response) {
                    var zoneName = response.nearest_zone;
                    if (!zoneName) {
                        return actions.error(new Error('zone name is empty'));
                    }
                    cancelZone_1 = zoneInfo({
                        body: {
                            zone_name: zoneName,
                        },
                        onError: actions.error,
                        onSuccess: function (response, headers) {
                            dispatch(setZoneName({ name: zoneName }));
                            actions.success(response, headers);
                        },
                    });
                },
            });
            return function () { return cancelZone_1(); };
        }
    }, [actions, dispatch, suggest, zoneInfo, zonePoint]);
    return asyncState;
};
export var useZoneInfoState = function () { return useZoneInfoAsync()[0]; };
export var useTariffsState = function () {
    var state = useStoreContext()[0];
    var zoneInfo = useZoneInfoState();
    return {
        status: zoneInfo.status,
        error: zoneInfo.error,
        data: getTariffsState(state),
    };
};
export var useRequirementsState = function (tariff) {
    var _a = useTariffsState(), tariffs = _a.data, status = _a.status, error = _a.error;
    var zoneTariff = tariffs === null || tariffs === void 0 ? void 0 : tariffs.find(function (t) { return t.class === tariff; });
    return {
        status: status,
        error: error,
        data: zoneTariff === null || zoneTariff === void 0 ? void 0 : zoneTariff.supported_requirements,
    };
};
